<template>
  <div class="white-paper-form">
      <SloButton
        v-if="canAccess"
        @click="download()"
        size="large"
        class="w-100 block text-center"
      >
      {{ 'Download White Paper' | t }}
      </SloButton>
    <div v-else>
      <h2>{{ 'Download the free white paper'|t }}</h2>
      <div v-if="error" class="white-paper-form--error alert alert-danger">
          {{ 'Form validation error, please try again.' | t }}
      </div>
      <form @submit.prevent="record()" method="post" class="mt-md cf-turnstile-verify">
        <SloField>
          <SloLabel>{{ 'First Name' | t }}</SloLabel>
          <SloInput
            v-model="firstName"
            name="firstName"
            type="text"
            inputmode="text"
          />
        </SloField>
        <SloField>
          <SloLabel>{{ 'Last Name' | t }}</SloLabel>
          <SloInput
            v-model="lastName"
            name="lastName"
            type="text"
            inputmode="text"
          />
        </SloField>
        <SloField>
          <SloLabel>{{ 'Email Address' | t }}</SloLabel>
          <SloInput
            v-model="email"
            name="email"
            type="email"
            inputmode="email"
            required
          />
        </SloField>
        <SloField>
          <SloLabel>{{ 'Job Type' | t }}</SloLabel>
          <SloSelect
            v-model="segment"
            name="segment"
            required
          >
            <option value="student">Student</option>
            <option value="Architect">Architect</option>
            <option value="Account Manager">Account Manager</option>
            <option value="Building Owner">Building Owner</option>
            <option value="Consultant">Consultant</option>
            <option value="Contractor">Contractor</option>
            <option value="Designer">Designer</option>
            <option value="Distributor">Distributor</option>
            <option value="Engineer">Engineer</option>
            <option value="Facility Manager">Facility Manager</option>
            <option value="Government">Government Professional</option>
            <option value="Healthcare">Healthcare Professional</option>
            <option value="Maintenance">Maintenance Manager</option>
            <option value="Manufacturer">Manufacturer</option>
            <option value="Plumber">Plumber</option>
            <option value="Principals">Principal</option>
            <option value="Property Manager">Property Manager</option>
            <option value="Real Estate">Realtor</option>
            <option value="Restaurant">Restaurant Professional</option>
            <option value="Retail">Retailer</option>
            <option value="Sales Rep">Sales Rep</option>
            <option value="Superintendents">Superintendent</option>
            <option value="Other">Other</option>
          </SloSelect>
        </SloField>
        <SloField>
          <SloLabel>{{ 'Postal Code' | t }}</SloLabel>
          <SloInput
            v-model="postalCode"
            name="postalCode"
            type="text"
            inputmode="text"
            required
          />
        </SloField>
        <div class="cf-turnstile-widget mb-md"></div>
        <SloButton type="submit" class="w-100 block text-center" :disabled="loading">
          <SloLoader v-if="loading" size="small" color="white" />
          <span v-else>{{ 'Access White Papers' | t }}</span>
        </SloButton>
      </form>
    </div>
  </div>
</template>

<script>
import t from '../main/i18n';
import SloButton from '../../lib/components/SloButton.vue';
import SloField from '../../lib/components/SloField.vue';
import SloInput from '../../lib/components/SloInput.vue';
import SloLabel from '../../lib/components/SloLabel.vue';
import SloLoader from '../../lib/components/SloLoader.vue';
import SloSelect from '../../lib/components/SloSelect.vue';

export default {
  name: 'WhitePaperRegistration',
  comments: true,
  components: {
    SloButton,
    SloField,
    SloInput,
    SloLabel,
    SloLoader,
    SloSelect
  },
  filters: {
    t
  },
  data() {
    return {
      loading: false,
      error: false,
      firstName: '',
      lastName: '',
      email: '',
      segment: '',
      postalCode: ''
    };
  },
  props: {
    url: {type: String, required: true}
  },
  computed: {
    canAccess() {
      return localStorage.getItem('whitePapersAccessEmail') &&
        localStorage.getItem('whitePapersAccessSegment') &&
        localStorage.getItem('whitePapersAccessPostalCode');
    }
  },
  methods: {
    download() {
      if (this.canAccess) {
        this.email = localStorage.getItem('whitePapersAccessEmail');
        this.segment = localStorage.getItem('whitePapersAccessSegment');
        this.postalCode = localStorage.getItem('whitePapersAccessPostalCode');

        this.record();

        window.open(this.url, '_blank');

        this.trackGAEvent();
      }
    },
    record() {
      this.loading = true;
      this.error = false;

      const self = this;

      // eslint-disable-next-line no-undef
      MktoForms2.loadForm('//info.sloan.com', '905-IOZ-761', 1612, function(form) {
        let fields = {
          'FirstName': self.firstName,
          'LastName': self.lastName,
          'Email': self.email,
          'segment': self.segment,
          'PostalCode': self.postalCode
        };

        form.vals(fields);
        form.validate();
        form.onValidate(status => {
          if (!status) {
            self.error = true;
            return false;
          }
        });

        form.submit();
        form.onSuccess(() => {
          self.loading = false;
          self.error = false;

          localStorage.setItem('whitePapersAccessFirstName', self.firstName);
          localStorage.setItem('whitePapersAccessLastName', self.lastName);
          localStorage.setItem('whitePapersAccessEmail', self.email);
          localStorage.setItem('whitePapersAccessSegment', self.segment);
          localStorage.setItem('whitePapersAccessPostalCode', self.postalCode);

          window.open(self.url, '_blank');
          window.location.reload();

          self.trackGAEvent();

          return false;
        });
      });
    },
    trackGAEvent() {
      window.ga('send', 'event', {
        eventCategory: 'whitepaper',
        eventAction: 'download',
        eventLabel: 'product whitepaper'
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';
@import '../../scss/system';

.white-paper-form {
  margin-top: 30px;
  padding: 30px;
  background-color: $gray-light;

  @media (min-width: $screen-sm-min) {
    width: 100%;
  }

  @media (min-width: $screen-md-min) {
    width: 370px;
    margin-top: 0;
    margin-left: 30px;
  }

  h2 {
    margin-top: 0;
    font-size: $font-size-h3;
    font-weight: $medium;
    color: $brand-primary;
  }
}
</style>
